import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { PLANS } from "../../lib/content";

const rates = [
  { label: "Acceptance", value: "0.70%" },
  { label: "Payouts", value: "0.35%" },
  { label: "Conversion", value: "0.40%" },
  { label: "Settlement out", value: "Free" },
];

export const Pricing = () => (
  <section id="pricing" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-4">Pricing</p>
        <h2 className="font-heading max-w-2xl text-3xl font-medium tracking-tight text-[#0A0C14] sm:text-4xl lg:text-5xl">
          Published rates. No hidden spread.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-slate-200 bg-slate-200 sm:grid-cols-4" data-testid="pricing-rates">
          {rates.map((r) => (
            <div key={r.label} className="bg-[#FAFAFB] p-6 text-center lg:p-8">
              <p className="font-heading text-3xl font-medium tracking-tight text-[#3B5FE8] lg:text-4xl">{r.value}</p>
              <p className="mt-1 text-xs uppercase tracking-widest text-slate-500">{r.label}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="mt-12 grid gap-6 lg:grid-cols-3">
        {PLANS.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.08}>
            <article
              data-testid={`pricing-plan-${p.name.toLowerCase()}`}
              className={`relative h-full rounded-3xl border p-8 transition-shadow duration-300 lg:p-10 ${
                p.featured
                  ? "border-[#3B5FE8] bg-white shadow-[0_20px_50px_rgba(59,95,232,0.15)] lg:-translate-y-3"
                  : "border-slate-200 bg-[#FAFAFB] hover:shadow-[0_12px_30px_rgba(10,12,20,0.06)]"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-8 rounded-full bg-[#3B5FE8] px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-white">Most popular</span>
              )}
              <h3 className="font-heading text-xl font-medium text-[#0A0C14]">{p.name}</h3>
              <p className="mt-1 text-sm text-slate-500">{p.desc}</p>
              <p className="font-heading mt-6 text-5xl font-medium tracking-tighter text-[#0A0C14]">
                {p.price}<span className="text-lg text-slate-400">{p.period}</span>
              </p>
              <ul className="mt-8 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-3 text-sm text-slate-600">
                    <Check size={15} className="shrink-0 text-[#3B5FE8]" /> {f}
                  </li>
                ))}
              </ul>
              <a
                href="#waitlist"
                data-testid={`pricing-cta-${p.name.toLowerCase()}`}
                className={`mt-10 block rounded-full py-3 text-center text-sm font-semibold transition-colors duration-200 ${
                  p.featured ? "btn-primary" : "border border-slate-300 text-slate-700 hover:border-[#3B5FE8] hover:text-[#3B5FE8]"
                }`}
              >
                Get early access
              </a>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 text-center text-sm text-slate-400">
          Volume tiers down to 0.25% acceptance at platform scale · Custom wholesale pricing for embedded partners
        </p>
      </Reveal>
    </div>
  </section>
);
